import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import {useHistory, useLocation} from 'react-router-dom';
import {URI_INTERNAL} from '../../utils/pathLocations';import {
    createUrlWithParam,
    getInfomationAccountFromToken,
} from '../../utils/helper';
import { PROJECT_API } from "@app/utils/apiUrl";
import { useMutation, useQuery } from 'react-query';
import {Post,Put, Get, DeleteSingle} from '@app/utils/httpProvider';
import {toast} from 'react-toastify';
import { Row, Col, Table, Button, Modal, Tag, Tooltip,Input, Select, Form  } from 'antd';
import { EditOutlined  } from '@ant-design/icons';
import {
    lstStatus,
    messageToast
} from '../../utils/define';

const Project = () => {
    const history = useHistory();
    const location = useLocation();
    const account = getInfomationAccountFromToken();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState('');
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        const pageResult = parseInt(paramUrl.get('page'), 10);
        setPage(pageResult);
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        const sizeResult = parseInt(paramUrl.get('size'), 10);
        setPageSize(sizeResult);
    }
    
    const { data, error, refetch } = useQuery(['getAll', page, pageSize, search ], () =>
        Get(PROJECT_API.GET_PAGING_ALL, null, {
            PageIndex: page,
            PageSize: pageSize,
            Keyword: search ? search : '',
        })
    );

    useEffect(() => {
      const handler = setTimeout(() => {
        refetch();
      }, 500);
      return () => {
        clearTimeout(handler);
      };
    }, [pageSize, page, search]);
    const replaceHistory = async (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.PROJECT_PATH, {
                page: Page,
                size: Size,
                search: Search ?? "", 
            })
        );
    };
    React.useEffect(() => {
        if (search) {
            replaceHistory(1, pageSize, search);
        }
    }, [search]);
      const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };
    const addFunc = useMutation((value) =>
        Post(PROJECT_API.ADD_ITEM, null, value, false)
      );
    const editFunc = useMutation(({ id, data }) =>
        Put(PROJECT_API.EDIT_ITEM, id, data)
    );
    const handleCreateModal = async () => {
      setIsModalOpen(true);

    }
    const handleCreate = async ()=> {
        const model = {};
        addFunc.mutate(model, {
        onSuccess: (res) => {
            if (res) {
                toast.success(messageToast.messageToastCreateSuccess);
                window.location.reload();
            } else {
                toast.error(messageToast.messageToastCreateError);
                history.goBack();
            }
        },
        onError: (res) => {
            toast.error(
                res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
            );
        }
    })}
    const handleEdit = async ()=> {
        const idUpdate  = "";
        const model = {};
        editFunc.mutate({ id: idUpdate, data: model }, {
        onSuccess: (res) => {
            if (res) {
                toast.success(messageToast.messageToastUpdateSuccess);
                window.location.reload();
            } else {
                toast.error(messageToast.messageToastUpdateError);
                history.goBack();
            }
        },
        onError: (res) => {
            toast.error(
                res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
            );
        }
    })}
    const deleteFunc = useMutation((value) =>
        DeleteSingle(PROJECT_API.DELETE_ITEM, value, null)
    );
    const acceptDelete = async () => {
        const idWantDelete = '';
        if (idWantDelete !== '') {
            deleteFunc.mutate(idWantDelete, {
                onSuccess: (res) => {
                    if (res.status === 201 || res.status === 200) {
                        refetch();
                        toast.success(messageToast.messageToastDeleteSuccess);
                    } else {
                        toast.error(messageToast.messageToastDeleteError);
                    }
                },
                onError: (res) => {
                    toast.error(messageToast.messageToastTryCatch);
                }
            });
            setOpenConfirmDeleteModal(false);
        }
    };
    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };
    const rawColumns = [
            {
              title: 'STT',
              dataIndex: 'stt',
              key: 'stt',
              render: (text, record, index) => index + 1,
              },
              {
                title: 'Tên gói thầu',
                dataIndex: 'tengoithau',
                key: 'tengoithau',
              },
             {
              title: 'Tổng tiền',
              dataIndex: 'tongtien',
              key: 'tongtien',
              }
          ];
          const handleOk = () => {
            form.validateFields().then((values) => {
                const model = {
                    tennganh: values.tennganh,
                    tenkho: values.tenkho,  
                    kho: values.kho, 
                    makho: values.makho,  
                    trangthai: values.trangthai,
                };
                if(isCheckBtn == 0) {
                 editFunc.mutate({ id: idUpdate, data: model }, {
                    onSuccess: (res) => {
                        if (res) {
                            toast.success(messageToast.messageToastUpdateSuccess);
                            window.location.reload();
                        } else {
                            toast.error(messageToast.messageToastUpdateError);
                            history.goBack();
                        }
                    },
                    onError: (res) => {
                        toast.error(
                            res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                        );
                    }
                  })
                }
                if(isCheckBtn == 1) {
                  addFunc.mutate(model, {
                    onSuccess: (res) => {
                        if (res) {
                            toast.success(messageToast.messageToastCreateSuccess);
                            window.location.reload();
                        } else {
                            toast.error(messageToast.messageToastCreateError);
                            history.goBack();
                        }
                    },
                    onError: (res) => {
                        toast.error(
                            res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                        );
                    }
                  })
                }
            });
        };
            const handleCancel = () => {
              form.resetFields(); 
                setIsModalOpen(false);
            };  
    return(
    <>
        <Row className ="mb-2">
          { (account && account.role == 'admin' || account.role == 'manager') && 
          <>
            <Button className="mr-2" onClick={handleCreateModal}>
              Thêm mới 
            </Button>
          </>}
        </Row>
         <Table
            className="custom-table"
            style={{ width: '100%' }}
            rowKey="id"
            columns={rawColumns}
            dataSource={data?.data && data?.data}
            pagination={false}
          />
        <div className="row">
          <div className="col-sm-12">
              <div
                  className="dataTables_paginate paging_simple_numbers"
                  id="example2_paginate"
              >
                  <Pagination
                      itemClass="page-item"
                      linkClass="page-link"
                      innerClass="pagination pagination-sm no-margin pull-right"
                      activePage={page}
                      itemsCountPerPage={Number(
                          pageSize
                      )}
                      totalItemsCount={
                          data != null
                              ? data.totalRecords
                              : 0
                      }
                      pageRangeDisplayed={5}
                      onChange={(number) =>
                          changePage(number)
                      }
                  />
              </div>
          </div>
        </div>
        <Modal
        title={"Thêm thông tin"}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Lưu"
        cancelText="Hủy"
        width={{
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '40%',
      }}
      >
        <Form form={form} layout="vertical">
          <Row>
            {/* <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item
                name="tennganh"
                label="Ngành"
                rules={[{ required: true }]}
                style={{ marginRight: 10 }}
              >
                <Select
                  placeholder="Chọn ngành"
                  options={dataNganh?.data?.data?.map(item => ({
                    label: item.tennganh,
                    value: item.tennganh 
                  }))}
                />
              </Form.Item>
            </Col> */}
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item name="tengoithau" label="Tên gói thầu" rules={[{ required: true }]} style={{marginRight: 10}}>
                <Input />
              </Form.Item>
            </Col>
            
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <Form.Item name="tongtien" label="Tổng tiền" rules={[{ required: true }]} style={{marginRight: 10}}>
                <Input />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={24} md={24} lg={12} xl={12} >
              <Form.Item name="trangthai" label="Trạng thái" rules={[{ required: true }]}>
                <Select
                  placeholder="Chọn trạng thái"
                  options={lstStatus}
                />
              </Form.Item>
            </Col> */}
          </Row>
        </Form>
      </Modal>
    </>
    )
}
export default Project;
